// material-ui
import { styled } from "@mui/material/styles";
import LinearProgress from "@mui/material/LinearProgress";
import { makeStyles } from "@material-ui/core";
import { color } from "../assets/const/color";

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiLinearProgress-colorPrimary": {
      backgroundColor: color.lightGreen,
    },
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: "#FEB62C",
    },
  },
}));

// loader style
const LoaderWrapper = styled("div")(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: 2001,
  width: "100%",
  "& > * + *": {
    marginTop: theme.spacing(2),
  },
  "& span": {
    height: "5px",
  },
}));

const LoaderWrapperr = styled("div")(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: 2001,
  width: "100%",
  "& > * + *": {
    marginTop: theme.spacing(2),
  },
}));

// ==============================|| Loader ||============================== //

const Loader = () => {
  const classes = useStyles();
  return (
    <LoaderWrapper className={classes.root}>
      <LinearProgress />
    </LoaderWrapper>
  );
};

export const TableLoader = () => {
  const classes = useStyles();
  return (
    <LoaderWrapperr className={classes.root}>
      <LinearProgress />
    </LoaderWrapperr>
  );
};

export default Loader;
